import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { SelectOption } from "src/models/FormField/FormField.model";
import { useNavigate } from "react-router-dom";
import {
  setPanSearchHistoryValue,
  setItrSearchHistoryValue,
  setDscSearchHistoryValue,
  setGumastaSearchHistoryValue,
  setMsmeSearchHistoryValue,
} from "src/redux/slices/SearchHistorySlice";
import { useDispatch, useSelector } from "react-redux";
import GloballySearch from "./GloballySearch";
import { RootState } from "src/redux/store";

export type SearchInitialValues = {
  srnNumber: string;
  searchType: string;
  service: string;
};
const services: SelectOption[] = [
  {
    label: "PAN",
    value: "pan",
  },
  {
    label: "ITR",
    value: "itr",
  },
  {
    label: "GUMASTA",
    value: "gumasta",
  },
  {
    label: "DSC",
    value: "dsc",
  },
  {
    label: "MSME",
    value: "msme",
  },
];

const searchOption: SelectOption[] = [
  {
    label: "SRN",
    value: "SRN",
  },
  {
    label: "ACK No.",
    value: "ACK",
  }
];
export type DropdownOptions = {
  services: SelectOption[];
  searchOption: SelectOption[];
};

const dropdownOptions: DropdownOptions = {
  services,
  searchOption
};
const GloballySearchWrapper = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const { panSearchHistoryValue }: any = useSelector(
  //     (state: RootState) => state.searchHistory
  // ); 
  // const { dscSearchHistoryValue }: any = useSelector(
  //   (state: RootState) => state.searchHistory
  // );
  // const { gumastaSearchHistoryValue }: any = useSelector(
  //   (state: RootState) => state.searchHistory
  // );
  // const { itrSearchHistoryValue }: any = useSelector(
  //   (state: RootState) => state.searchHistory
  // );

  // const { msmeSearchHistoryValue }: any = useSelector(
  //   (state: RootState) => state.searchHistory
  // );
  

    const {
    panSearchHistoryValue,
    dscSearchHistoryValue,
    itrSearchHistoryValue,
    gumastaSearchHistoryValue,
    msmeSearchHistoryValue,
  }: any = useSelector((state: RootState) => state.searchHistory);

  const getSearchTypeByService = (service: string) => {
    switch (service) {
      case "pan":
        return panSearchHistoryValue?.searchType || "SRN";
      case "dsc":
        return dscSearchHistoryValue?.searchType || "SRN";
      case "itr":
        return itrSearchHistoryValue?.searchType || "SRN";
      case "gumasta":
        return gumastaSearchHistoryValue?.searchType || "SRN";
      case "msme":
        return msmeSearchHistoryValue?.searchType || "SRN";
      default:
        return "SRN";
    }
  };

  const initialValues: SearchInitialValues = {
    srnNumber: "",
    searchType:getSearchTypeByService("pan"),
    service: "pan",
  };
  const navigateAndSetSRN = ({ srnNumber, service, searchType }: SearchInitialValues) => {
     const payload = { srnNumber, searchType };
     console.log("payload", payload)
    switch (service) {
      case "pan":
        dispatch(setPanSearchHistoryValue(payload));
        navigate("/search-history/pan");
        break;

      case "itr":
        dispatch(setItrSearchHistoryValue(payload));
        navigate("/search-history/itr");
        break;

      case "msme":
        dispatch(setMsmeSearchHistoryValue(payload));
        navigate("/search-history/msme");
        break;
      case "gumasta":
        dispatch(setGumastaSearchHistoryValue(payload));
        navigate("/search-history/gumasta");
        break;
      case "dsc":
        dispatch(setDscSearchHistoryValue(payload));
        navigate("/search-history/dsc");
        break;
    }
  };
  const onSubmit = ({ srnNumber, service, searchType }: SearchInitialValues) => {
    navigateAndSetSRN({ srnNumber, service, searchType });
  };

  
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {(formikProps) => (
        <Form>
          <GloballySearch
            formikProps={formikProps}
            dropdownOptions={dropdownOptions}
          />
        </Form>
      )}
    </Formik>
  );
};

export default GloballySearchWrapper;
